import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'

console.log('[FreedomCert Web] Starting Vite app...')

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
  console.log('[FreedomCert Web] App rendered successfully')
} catch (error) {
  console.error('[FreedomCert Web] Failed to render app:', error)
}
